import { Component } from 'vue-property-decorator'
import { UstraComponent } from '@ustra/nuxt/src/vue/components/ustra-component'
import layoutDataEventBus from '../event-bus/layout-data-event-bus'
import * as ConstantKeys from '../utils/constant-keys'

@Component({
  config: {
    auth: {
      required: true,
    },
    route: {
      includeHistory: (_to, from) => {
        return from.depth <= _to.depth
      },
    },
  },
})
export default class HsComponent extends UstraComponent {
  // #region variables
  /**
   * 컴포넌트 옵션에 설정된 Title
   *
   * @readonly
   * @memberof HsComponent
   */
  get layoutTitle() {
    return this.$nuxt.context.app.pageConfig?.title
  }

  /**
   * 컴포넌트 옵션에 설정된 LayoutType
   *
   * @readonly
   * @memberof HsComponent
   */
  get layoutType() {
    return this.$nuxt.context.app.pageConfig?.layoutType
  }

  /**
   * 레이아웃 옵션
   *
   * @readonly
   * @memberof HsComponent
   */
  get layoutOptions() {
    return this.$nuxt.context.app.pageConfig?.options
  }

  get rules() {
    return ConstantKeys.RULES
  }

  // #endregion
  // #region hooks
  created() {
    layoutDataEventBus.emit({ title: this.layoutTitle, layoutType: this.layoutType, options: this.layoutOptions })
  }
  // #endregion
  // #region methods
  // #endregion
  // #region watches
  // #endregion
}

export { HsComponent }
